<template>
  <div class>
    <div class="outmain ba_f">
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('finance.withdrawalSettings.title') }}</span>
        </div>
      </div>
      <el-form ref="form" :model="form" label-width="180px" class="mar_t20">
        <el-form-item :label="$t('finance.withdrawalSettings.enableWithdraw')">
          <el-radio-group v-model="form.open">
            <el-radio label="1">{{ $t('finance.withdrawalSettings.enable') }}</el-radio>
            <el-radio label="2">{{ $t('finance.withdrawalSettings.close') }}</el-radio>
          </el-radio-group>
          <div class="yb_margin lh16">{{ $t('finance.withdrawalSettings.enableTip') }}</div>
        </el-form-item>
        <div v-if="form.open=='1'">
          <el-form-item :label="$t('finance.withdrawalSettings.withdrawChannel')">
            <el-checkbox-group v-model="form.channel">
              <el-checkbox label="1">{{ $t('finance.withdrawalSettings.wechat') }}</el-checkbox>
              <el-checkbox label="2">{{ $t('finance.withdrawalSettings.alipay') }}</el-checkbox>
              <el-checkbox label="3">{{ $t('finance.withdrawalSettings.bankCard') }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item :label="$t('finance.withdrawalSettings.minAmount')">
            <el-input v-model="form.downMoney" type="number" :placeholder="$t('finance.withdrawalSettings.minAmountPh')">
              <template slot="append">{{ $t('common.yuan') }}</template>
            </el-input>
            <div class="yb_margin lh16">{{ $t('finance.withdrawalSettings.minAmountTip') }}</div>
          </el-form-item>
          <el-form-item :label="$t('finance.withdrawalSettings.feeRate')">
            <el-input v-model="form.rate" type="number" :placeholder="$t('finance.withdrawalSettings.feeRatePh')">
              <template slot="append">%</template>
            </el-input>
            <div class="yb_margin lh16">{{ $t('finance.withdrawalSettings.feeRateTip') }}</div>
          </el-form-item>
          <el-form-item :label="$t('finance.withdrawalSettings.withdrawFee')">
            <el-input v-model="form.rateDownMoney" type="number" :placeholder="$t('finance.withdrawalSettings.withdrawFeePh')">
              <template slot="prepend">{{ $t('finance.withdrawalSettings.min') }}</template>
              <template slot="append">{{ $t('common.yuan') }}</template>
            </el-input>/
            <el-input v-model="form.rateUpMoney" type="number" :placeholder="$t('finance.withdrawalSettings.amountPh')">
              <template slot="prepend">{{ $t('finance.withdrawalSettings.max') }}</template>
              <template slot="append">{{ $t('common.yuan') }}</template>
            </el-input>
            <div class="yb_margin lh16">{{ $t('finance.withdrawalSettings.withdrawFeeTip') }}</div>
          </el-form-item>
          <el-form-item :label="$t('finance.withdrawalSettings.interval')">
            <el-input v-model="form.day" type="number" :placeholder="$t('finance.withdrawalSettings.intervalPh')">
              <template slot="append">{{ $t('finance.withdrawalSettings.day') }}</template>
            </el-input>
            <div class="yb_margin lh16">{{ $t('finance.withdrawalSettings.intervalTip') }}</div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="mar_t20 ba_f pad_20 t_c">
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</template>
<script>
import { getConfig, postConfig } from "@/api/set";
export default {
  created() {
    this.init();
  },
  data() {
    return {
      form: {
        open: "2",
        channel: ["1"],
        downMoney: "",
        rate: "",
        rateDownMoney: "",
        rateUpMoney: "",
        day: "",
      },
    };
  },
  methods: {
    async init() {
      const { data } = await getConfig({ ident: "withdrawal" });
      this.form2 = this.form;
      this.form = Object.assign(this.form2, data);
    },
    submitForm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.form.ident = "withdrawal";
          const { msg } = await postConfig(this.form);
          this.$baseMessage(msg, "success");
          this.init();
        } else {
          return false;
        }
      });
    },
  },
};
</script>
